import React from 'react';
import {makeStyles} from '@mui/styles';
import { Grid, CircularProgress } from '@mui/material';

const useStyles = makeStyles({
    progress: {
        width: '100%',
        height: '100%',
        margin: '50px auto'
    }
});

const BglLoader = () => {
    const classes = useStyles();

    return (
        <Grid container justifyContent={'center'}>
            <Grid item>
                <CircularProgress className={classes.progress} color="secondary"/>
            </Grid>
        </Grid>
    );
};

export default BglLoader;
